/**
 * 온보딩이 묻는 **정체성**. 가입자가 스스로를 고르고, 그 답이 프로필의 얼굴이 된다.
 *
 * 순서가 곧 화면 순서다. 키는 저장값이라 바꾸지 않는다 — 라벨·설명만 고친다.
 */
export const IDENTITIES = [
    { key: 'lion', emoji: '🦁', label: '사자', desc: '엑싯 경험자. 엑싯 후 먹고 살만한 자.' },
    { key: 'boar', emoji: '🐗', label: '멧돼지', desc: '창업가. 창업에 돌진하는 자.' },
    { key: 'sheep', emoji: '🐑', label: '양', desc: '좋소의 희생양. 타인의 지시로 일하는 자.' },
    { key: 'eagle', emoji: '🦅', label: '독수리', desc: '바운티헌터. 스스로 꽁돈을 찾는 자.' },
    { key: 'fox', emoji: '🦊', label: '여우', desc: '멘토/컨설턴트. 사업계획서 고수.' },
    { key: 'cat', emoji: '😼', label: '고양이', desc: '구경꾼. 기웃거리는 구경꾼.' },
    { key: 'chick', emoji: '🐣', label: '병아리', desc: '신입. 이제 막 분위기 파악하려는 자.' },
];
export const IDENTITY_KEYS = IDENTITIES.map((i) => i.key);
export const identityOf = (key) => IDENTITIES.find((i) => i.key === key) ?? null;
/** 설명의 첫 문장 = 역할. 「바운티헌터. 스스로 꽁돈을 찾는 자.」→ 「바운티헌터」. 프로필은 동물명 대신 이걸 보인다. */
export const identityRole = (it) => it.desc.split('.')[0].trim();
/** 역할 뒤의 설명. 「스스로 꽁돈을 찾는 자.」 */
export const identityTagline = (it) => it.desc.slice(it.desc.indexOf('.') + 1).trim();
/** 「그래서 여기는 왜 오셨나요?」 */
export const VISIT_REASONS = [
    { key: 'bounty', label: '꽁돈 따먹는데 도움이 될까해서.' },
    { key: 'advice', label: '남들한테 조언을 듣고 싶어서.' },
    { key: 'startup_info', label: '창업 정보를 구하려고.' },
    { key: 'team_building', label: '정부지원과제에 관련 도움을 주고 받기 위해.' },
    { key: 'job', label: '직업상 도움이 되려나 싶어서.' },
    { key: 'passing_by', label: '그냥 지나가다가 우연히.' },
];
export const VISIT_REASON_KEYS = VISIT_REASONS.map((r) => r.key);
/** 「어떤 걸 따먹어 봤었나요?」 — 따먹은 횟수가 1 이상일 때만 묻는다. */
export const GRANT_KINDS_WON = [
    { key: 'tips', label: 'TIPS' },
    { key: 'rnd', label: 'R&D' },
    { key: 'policy_fund', label: '정책자금' },
    { key: 'employment', label: '고용지원' },
    { key: 'startup', label: '창업지원' },
    { key: 'export', label: '수출지원' },
    { key: 'other', label: '기타' },
];
export const GRANT_KIND_WON_KEYS = GRANT_KINDS_WON.map((k) => k.key);
/**
 * 정체성으로 만든 닉네임 — 「🦅독수리4821」. 가입 때 붙은 임시 이름(「엉뚱한사원888」)을
 * 첫 온보딩에서 이걸로 바꾼다. 숫자는 네 자리 난수라 충돌하면 다시 뽑는다(서버).
 */
export function identityNickname(identity, seed = Math.random()) {
    const it = IDENTITIES.find((i) => i.key === identity);
    const n = 1000 + Math.floor(seed * 9000);
    return `${it.emoji}${it.label}${n}`;
}
/** 자동으로 지은 이름인가 — 「🐣병아리4821」 꼴. 직접 지은 이름은 정체성을 바꿔도 안 건드린다. */
export function isAutoNickname(nickname) {
    return IDENTITIES.some((i) => new RegExp(`^${i.emoji}${i.label}\\d{4}$`, 'u').test(nickname));
}
//# sourceMappingURL=identity.js.map